"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DETECT_PORT_IN_USE_TIMEOUT = void 0;
exports.DETECT_PORT_IN_USE_TIMEOUT = 20 * 1000;
